<template>
	<div class="d-flex">
		<v-icon small class="mr-1" :color="isLiked ? 'red' : 'grey darken-1'">
			{{ isLiked ? 'mdi-heart' : 'mdi-heart-outline' }}
		</v-icon>
		<span class="mr-2">{{ item.nbLikes }}</span>
		
		<v-icon small class="mr-1" :color="isCommented ? 'comment' : 'grey darken-1'">
			{{ isCommented ? 'mdi-comment-text' : 'mdi-comment-text-outline' }}
		</v-icon>
		<span class="mr-2">{{ item.nbComments }}</span>
		
		<v-icon small class="mr-1" :color="isFeedbacked ? 'feedback' : 'grey darken-1'">mdi-book</v-icon>
		<span>{{ item.nbFeedbacks }}</span>
	</div>
</template>


<script>
import { mapGetters } from 'vuex';
import { toRelativeDate } from '@/utils/formatters';

export default {
	name: "action-stats",
	props: {
		'item': { type: Object },
	},
	computed: {
		...mapGetters('auth', ['userID']),
		isLiked() {
			return this.$store.getters['likes/hasUserLikedAction'](this.item.id, this.userID);
		},
		isCommented() {
			return this.$store.getters['comments/hasUserCommentedAction'](this.item.id, this.userID);
		},
		isFeedbacked() {
			return this.$store.getters['feedbacks/hasUserFeedbackedAction'](this.item.id, this.userID);
		},
	},
	filters: {
		toRelativeDate,
	},
};
</script>
